import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import ContactEditor from './ContactEditor';

function EditContact() {
	const { id } = useParams();
	const navigate = useNavigate();
	const { returnTo } = useEditorReturn();

	const handleClose = () => {
		navigate(returnTo || '/AdminScreen/contacts');
	};

	const handleSaved = () => {
		navigate(returnTo || '/AdminScreen/contacts');
	};

	return (
		<EntityList>
			<Helmet>
				<title>Editar Contacto</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Contactos', to: '/AdminScreen/contacts' },
					{ label: 'Editar Contacto' },
				]}
				title='Editar Contacto'
				subtitle='Actualizá los datos principales del contacto.'
			/>
			<ContactEditor
				onClose={handleClose}
				onSaved={handleSaved}
				initialData={{ _id: id }}
				isEditing={true}
				cancelHandler={handleClose}
				allowCreateRoundTrip
			/>
		</EntityList>
	);
}
export default EditContact;
